import { fetcher } from "./api";

export const SWROptions = {
  fetcher,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  errorRetryInterval: 500,
  errorRetryCount: 3,
};
